import { useState } from 'react';
import { TiPlus, TiMinus } from 'react-icons/ti';
import { FAQ } from '../../data/faqs';
import './FAQs.css';

const FAQs  = () =>  {
const [clickedIndex, setClickedIndex] = useState({});
const [isOpen, setIsOpened] = useState(false);

	const handleToggleQuiz = (index) => () => {
		setClickedIndex(state =>({...state, [index]: !state.index}));
	}
		return (
			<div className="faqs">
				<h1>FAQ</h1>

				<div className="questions">
					{
						FAQ.map((quiz, index) =>(
							<div className="question-container" key={quiz.id}>
								<div className="quiz-head" onClick={(index) => setIsOpened(!isOpen)}>
										<h5>0{index + 1}. {quiz.header} </h5>
										<i> {isOpen ? <TiMinus /> : <TiPlus />}</i>
									</div>
									 {
										isOpen && (<p>{quiz.description}</p>)
									 }
							</div>
						))
					}
				</div>
			</div>
		);
}

export default FAQs;
